import { Sidebar } from "primereact/sidebar";
import styles from "./index.module.scss";
import { useParams } from "react-router-dom";
import { formatCurrency } from "../../../../utils/utils";
import { numberWithCommas } from "../../../../utils/const";
import PlaceOffer from "../../../property-detail/place-offer";

interface PropType {
  visiblePlaceBid: boolean;
  setVisiblePlaceBid: (visible: boolean) => void;
  objPropertyDetails: any;
}
export default function MobilePlaceBidSlider({
  visiblePlaceBid,
  setVisiblePlaceBid,
  objPropertyDetails
}: PropType) {
  const { propertyId } = useParams();

  return (
    <Sidebar
      visible={visiblePlaceBid}
      position="bottom"
      onHide={() => setVisiblePlaceBid(false)}
      className={styles.mobilePlaceBid}
      maskClassName={styles.mobilePlaceBidMask}
      header={<div className={styles.mobilePlaceBidHeader}>Place Bid</div>}
    >
      <div className={styles.scrollableContent}>
        <div className={styles.imgBox}>
          <img
            src={objPropertyDetails?.images[1]?.url}
            alt=""
            className={styles.closeIcon}
          />
        </div>
        <div className={styles.DetailsInfo}>
          <div className={styles.amount}>
            {formatCurrency(+objPropertyDetails?.askingPrice, "USD", "en-us")}
          </div>
          <div className={styles.accessoriesListing}>
            {(objPropertyDetails?.beds || objPropertyDetails?.bedRooms) && (
              <div className={styles.accessory}>
                <span>
                  {objPropertyDetails?.beds || objPropertyDetails?.bedRooms}
                </span>{" "}
                Bed
              </div>
            )}
            {(objPropertyDetails?.baths || objPropertyDetails?.totalBath) && (
              <div className={styles.accessory}>
                <span>
                  {objPropertyDetails?.baths || objPropertyDetails?.totalBath}
                </span>{" "}
                Bath
              </div>
            )}
            {objPropertyDetails?.lotSizeSqFt && (
              <div className={styles.accessory}>
                <span>{numberWithCommas(objPropertyDetails?.lotSizeSqFt)}</span>{" "}
                Sq.Ft
              </div>
            )}
          </div>
          <div className={styles.address}>
            {objPropertyDetails?.address?.split(",")[0]}
            <div className={styles.location}>
              <span> {objPropertyDetails?.address?.split(",")[1]}</span>
              <span>, {objPropertyDetails?.address?.split(",")[2]}</span>
            </div>
          </div>
        </div>
        <PlaceOffer
          sifd={objPropertyDetails?.sfid}
          isMobile={true}
          propertyId={propertyId}
          bidCount={objPropertyDetails?.bidCount}
        />
      </div>
    </Sidebar>
  );
}
